// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609090749/js/" + chunkId + "." + {"44":"d164ca57","225":"698e0195","481":"be7bfe00","486":"b4eec0ca","770":"b75549f4"}[chunkId] + ".0.9900944245290773.chunk.js";
};